import React from 'react'

import data_services from "./Service.data"
import ServiceCard from "./ServiceCard"
const Services = () => {
    return (
        <div className="content services">

            <div className="title">My Services</div>


            <div className="row service-items border-line-v">
                {
                    data_services.map(serv =>
                        <ServiceCard serv={serv} />
                    )
                }
            </div>
            <div className="clear"></div>

        </div>
    );
}

export default Services;